import { createTypes } from 'redux-action-creator'

const actionTypes = createTypes([
  'OPEN',
  'CLOSE'
], 'MODAL')

export { actionTypes }
